import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { OfferTypeFilter, RewardOfferType } from '@/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { CountryCode } from '@/store/ui';

@Component({
  name: 'CmgRewardsExchangeWelcomeModal',
})
export default class CmgRewardsExchangeWelcomeModal extends Vue {
  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get displayOfferTypes(): boolean {
    // TODO: Have the API filter offer types based on country and ensure NOO still works
    return this.$appStore.state.ui.countryProfile.countryCode !== CountryCode.CA
  }

  get offerTypes(): RewardOfferType[] {
    return this.$appStore.state.reward.offerTypes;
  }

  get visible(): boolean {
    const visible = this.$appStore.state.ui.modals.rewardsExchangeWelcome.visible;
    if (visible) {
      this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.RewardsStoreOnboard,
        action: AnalyticsEventAction.RewardsStoreModalView,
        label: AnalyticsEventLabel.RewardsStoreModal,
      });
    }

    return visible;
  }

  get pepperMedallionImageUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout.default;
  }

  onClickViewRewardsExchange() {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsStoreOnboard,
      action: AnalyticsEventAction.ViewRewardExchangeClick,
      label: AnalyticsEventLabel.RewardsStoreRewardExchangeClick,
    });

    this.onClose(false);
  }

  onClose(logEvent: boolean = true) {
    if (logEvent) {
      this.$services.googleAnalytics.sendCustomEvent({
        category: AnalyticsEventCategory.RewardsStoreOnboard,
        action: AnalyticsEventAction.RewardsStoreModalClose,
        label: AnalyticsEventLabel.RewardsStoreModal,
      });
    }
    this.$services.ui.setModalVisibility('rewardsExchangeWelcome', false);
    this.$services.ui.focusBack();
  }

  onClickTellMeMore(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsStoreOnboard,
      action: AnalyticsEventAction.TellMeMoreClick,
      label: AnalyticsEventLabel.TellMeMoreClick,
    });

    this.$services.ui.setModalVisibility('rewardsExchangeWelcome', false);
    this.$services.ui.setModalVisibility('rewardsSpendYourPoints', true);
  }

  offerTypeImageUrl(offerType: OfferTypeFilter): string {
    switch (offerType) {
      case OfferTypeFilter.Food:
        return this.$appStore.state.cms.images.logos.medallionEatNew.default;
      case OfferTypeFilter.Goods:
        return this.$appStore.state.cms.images.logos.medallionGoodsNew.default;
      case OfferTypeFilter.Giving:
        return this.$appStore.state.cms.images.logos.medallionGivingNew.default;
      default:
        return '';
    }
  }
}
